import React from "react";
import { Bestellliste } from "../components/Stückliste";
import { Option, TitleBlock } from "./OptionSelect";
import { MAuswahlwert } from "../../metamodell";
import { getHinweistexte } from "../arrangement/hinweistextFunctions";

/**
 * Sammlung von Standard-Auswahlmenüs (OptionSelect) auf einer Seite
 * Optional mit custom Children ganz unten
 * @param title Titel der Seite
 */
export function Abschluss({ title }: { title: string }) {
  return (
    <section
      id={`content_abschluss`}
      className="optionContent"
      aria-label={I18N("aria::Abschluss und Bestellung")}
    >
      <TitleBlock text={I18N("Bestellliste")} />
      <div className={"PartsList onPage"} role="region" aria-labelledby="bestellliste-title">
        <Bestellliste highlightElements={false} />
      </div>
      <br />
      <Hinweistexte />
    </section>
  );
}

function Hinweistexte() {
  const hinweistexte = getHinweistexte();

  if (Commons.isEmpty(hinweistexte)) return null;

  return (
    <section aria-labelledby="hinweise-title">
      <TitleBlock text={I18N("Hinweise")} />
      <ul aria-label={I18N("aria::Wichtige Hinweise zur Bestellung")}>
        {" "}
        {hinweistexte.map((hinweistext, index) => (
          <li key={"hinweis" + index} dangerouslySetInnerHTML={{ __html: hinweistext }}></li>
        ))}{" "}
      </ul>
    </section>
  );
}

function AusgewählteAuswahlen() {
  const auswahlwerte = APP.arrangement.konfiguration.getAusgewähleAuswahlwerte();

  return (
    <section className={"optionSelect AusgewählteOptionen"} aria-labelledby="optionen-title">
      <TitleBlock text={I18N("Ausgewählte Optionen")} />
      <div className="options" role="list">
        {auswahlwerte.map((auswahlwert: MAuswahlwert) => (
          <div key={auswahlwert.Key} role="listitem">
            <span
              dangerouslySetInnerHTML={{ __html: I18N("PDF_OPTION_" + auswahlwert.Auswahl.Key) }}
            ></span>
            <Option
              optionKey={"Abschluss"}
              isSelected={true}
              auswahlwert={auswahlwert}
              selectFunction={() => {}}
            />
            <br />
          </div>
        ))}
      </div>
    </section>
  );
}
